import BaseAction from '@/actions/base_action.js'

export default class extends BaseAction {
  execute(properties, component) {
    const promise = $tpu.r.checklists.update(
      properties.checklistId,
      properties.formData)
    this.executeCardUpdate(promise, properties, component, true)
  }
}
